// Smooth scroll to element with offset for fixed navbar
export const scrollToSection = (sectionId, offset = 100) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

// Handle hash navigation - works from any page
export const handleHashNavigation = (hash, navigate) => {
  // Remove # if present
  const sectionId = hash.replace('#', '');
  
  // If we're on home page, just scroll
  if (window.location.pathname === '/') {
    setTimeout(() => scrollToSection(sectionId), 100);
    return;
  }
  
  // If we're on another page, navigate to home first, then scroll
  navigate('/');
  setTimeout(() => {
    scrollToSection(sectionId);
  }, 300);
};
